
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" :class="styling" aria-label="Twitter">
    <path d="M20 2.799a8.549 8.549 0 0 1-2.363.647 4.077 4.077 0 0 0 1.804-2.266 8.194 8.194 0 0 1-2.6.993A4.099 4.099 0 0 0 9.75 4.977c0 .324.027.637.095.934-3.409-.166-6.425-1.8-8.452-4.288a4.128 4.128 0 0 0-.56 2.072c0 1.42.73 2.679 1.82 3.408A4.05 4.05 0 0 1 .8 6.598v.045a4.119 4.119 0 0 0 3.285 4.028 4.092 4.092 0 0 1-1.075.135c-.263 0-.528-.015-.776-.07.531 1.624 2.038 2.818 3.831 2.857A8.239 8.239 0 0 1 .981 15.34 7.68 7.68 0 0 1 0 15.285a11.543 11.543 0 0 0 6.29 1.84c7.545 0 11.67-6.25 11.67-11.667 0-.182-.006-.357-.015-.53A8.18 8.18 0 0 0 20 2.798z" fill="currentColor"/>
  </svg>
</template>

<script>

export default {
  props: {
    styling: {
      type: String,
      default: 'w-5 h-auto'
    }
  },

}
</script>